export type IssueSeverity = "error" | "warning" | "info";

export type IssueCode =
  | "schema-invalid"
  | "unknown-block"
  | "license-required"
  | "unknown-binding"
  | "invalid-expression"
  | "type-mismatch"
  | "invalid-condition"
  | "missing-collection"
  | "missing-required"
  | "missing-theme-token"
  | "missing-theme-value"
  | "unsupported-font"
  | "invalid-url"
  | "invalid-image"
  | "empty-content"
  | "empty-value"
  | "region-overflow"
  | "layout-invalid"
  | "scope-shadowing"
  | "duplicate-id"
  | "custom";

/**
 * Which question an issue answers.
 *
 * `template` issues are defects in the design itself: they are true for every
 * client the report is ever run for, and the designer has to fix them.
 * `output` issues are true only of the data in front of you — a field this
 * particular client has not filled in. Both matter, but conflating them makes
 * the first kind unfindable and the second kind look like the designer's fault.
 */
export type IssueSource = "template" | "output";

export interface Issue {
  severity: IssueSeverity;
  code: IssueCode;
  message: string;
  /** Defaults to "template". */
  source?: IssueSource;
  /** Node id the issue belongs to, when applicable. */
  nodeId?: string;
  /** Prop path on that node. */
  prop?: string;
  /** Region: body, header, footer, library. */
  region?: "body" | "header" | "footer" | "library" | "document";
  /** Optional machine-readable detail. */
  detail?: Record<string, unknown>;
}

export function issue(severity: IssueSeverity, code: IssueCode, message: string, extra: Partial<Issue> = {}): Issue {
  return { severity, code, message, ...extra };
}
